import axios from 'axios'
import { getBFFUrl, getToken } from './requests'

export const changeInvoice = async (saleID, date, billingInfo) => {
  const token = await getToken()

  const res = await axios.post(
    `${getBFFUrl()}/changeInvoice`,
    {
      saleID: saleID,
      date: date,
      billing: {
        vatNumber: billingInfo.nif,
        name: billingInfo.name,
        address: billingInfo.address,
        postalCode: billingInfo.postalCode,
        city: billingInfo.city,
        country: billingInfo.country,
      },
      operator: 'BALSAS',
    },
    {
      headers: {
        'x-access-token': token,
        operator: 'DemoBalsas',
      },
    }
  )

  return res.data.data
}
